import { render, staticRenderFns } from "./ChecksLegalsListComponent.vue?vue&type=template&id=0e5543b0"
import script from "./ChecksLegalsListComponent.vue?vue&type=script&lang=js"
export * from "./ChecksLegalsListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports